import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFourIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 12,
			fill: "#F7F8F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7734 14.9287H14.5703V17H12.5059V14.9287H8.24023V13.459L12.6221 7.00586H14.5703V13.2881H15.7734V14.9287ZM12.5059 13.2881V11.5928C12.5059 11.3102 12.5173 10.9001 12.54 10.3623C12.5628 9.82454 12.5811 9.51237 12.5947 9.42578H12.54C12.3714 9.79948 12.1686 10.1641 11.9316 10.5195L10.0996 13.2881H12.5059Z",
			fill: "parent"
		})
	]
});
const ForwardRef = forwardRef(SvgFourIcon);
export { ForwardRef as ReactComponent };
